import HeaderLink from '../../components/HeaderLink/HeaderLink';
import { Link } from 'react-router-dom';
import strings from '../../lang/lang';
import Button from '../../elements/Button/Button';
import popup from './Popup.module.scss';
import {keycloak} from "../../keycloak-config";

const LoginHeader = ({ type, showSignUp }) => {
  return (
    <>
      <div className={popup.popup__header}>
        <HeaderLink />
        {(showSignUp && !keycloak.authenticated) && (
          <Link to={'/'} onClick={() => type === 'signUp' ? keycloak.register() : keycloak.login()}>
            <Button name={strings.header.buttons[type]} variant="primary" />
          </Link>
        )}
      </div>
    </>
  );
};

LoginHeader.defaultProps = {
  type: 'signUp',
  showSignUp: true,
};

export default LoginHeader;
